import React from "react";
import {Link} from "react-router-dom";
import {Image} from "antd";
import {Player} from "@lottiefiles/react-lottie-player";
import Login from "../../page-components/auth/login/login";
import "../../styles/component/auth/login.scss";

const LoginPage = () => {
    return (
        <div className="login">
            <div className="loginPage">
                <div className="loginPageDetail">
                    <div className="left">
                        <div className="login-here">
                            <div className="login-here-detail">
                                <Image
                                    preview={false}
                                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/icons/people-nest-logo.svg`}
                                    alt="People Nest Logo"
                                    className="hrms-logo"
                                />
                                <p className="login-title-text">Welcome back !!!</p>
                                <h1 className="login-title-heading">Log In</h1>
                            </div>
                            {/* Login page component */}
                            <Login/>
                        </div>
                    </div>
                    <div className="right">
                        <div className="right-section-bg"/>
                        <div className="right-images">
                            <div className="girl">
                                <Player
                                    autoplay
                                    loop
                                    src="/assets/animation/login.json"
                                    style={{height: 400, width: 400}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginPage;